<template lang="html">
  <div id="company-page">

    <section class="main-section">
      <div class="placed-backg box-image"></div>

      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-5 col-xl-6 col-image"></div>

          <div class="col-lg-7 col-xl-6 col-text">
            <h1 class="mb-1 title">Empresa 100% Mexicana</h1>
            <p>
              Director general: Fernando Pacheco Rangel
            </p>
            <p>
              Contamos con: Registro SAT y Cofepris oficina matriz y bodega CDMX
            </p>

            <h5 class="mt-4 subtitle">Visión</h5>
            <p>
              Lograr que en México vivan personas sanas que logren su libertad financiera.
            </p>

            <h5 class="mt-4 subtitle">Filosofia</h5>
            <p>
              Ayudar a mejorar tu salud y tu economia.
            </p>

            <h5 class="mt-4 subtitle">Misión</h5>
            <p>
              Lograr a futuro ser la empresa No. 1 en salud natural y libertad financiera.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="extra-section">
      <div class="container">
        <h2 class="text-center title-2">Único sistema hecho 100% a tu favor</h2>

        <div class="row justify-content-center">
          <div class="col-6 col-sm-6 col-lg-4 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-1.svg">
            </div>

            <h5>Envíos a toda la república</h5>
            <!-- <p>
              Accede a todo el contenido sin restricciones por una tarifa fija.
            </p> -->
          </div>

          <div class="col-6 col-sm-6 col-lg-4 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-2.svg">
            </div>

            <h5>Formulas 100% naturales</h5>
          </div>

          <div class="col-6 col-sm-6 col-lg-4 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-3.svg">
            </div>

            <h5>Pago de comisiones semanales y mensuales</h5>
          </div>

          <div class="col-6 col-sm-6 col-lg-4 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-4.svg">
            </div>

            <h5>Sistema de capacitación</h5>
          </div>

          <div class="col-6 col-sm-6 col-lg-4 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-5.svg">
            </div>

            <h5>Oficina virtual personalizada p/c afiliado</h5>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
